module.exports = __webpack_public_path__ + "img/file.8bc79cec.svg";